import { login } from './login.js';
import { mockedLocalLoginResponse, shouldLoginPassOnLocal, } from '../../../helpers/env/local.js';
export const signInCandidate = async ({ email, password, rememberMe, loginSource, }) => {
    if (shouldLoginPassOnLocal()) {
        return mockedLocalLoginResponse();
    }
    const loginData = {
        email,
        password,
        rememberMe,
        loginSource,
    };
    return login(loginData);
};
//# sourceMappingURL=signInCandidate.js.map